import { useSyncExternalStore } from "react";
import { createExternalStore } from "./external-store.js";

// The two full stops a signed-in identity can hit, both set once by the failure handler and
// read by StaffGate to swap the whole shell for a terminal screen. Neither ever flips back
// client-side: nothing here retries, and signing out (each screen's one exit) reloads the app.
//
// `archived` — 403 auth.staff_archived: a staff row that has been retired.
// `unknownStaff` — 401 with a token presented: Clerk has a live session the API refuses
// (unknown staff row, or a verifier mismatch — the API says only 401 by design). Redirecting
// here would bounce against Clerk's own valid session forever; that loop is the reason this
// state exists (errors.ts's UnknownStaffError).

const archivedStore = createExternalStore(false);
const unknownStaffStore = createExternalStore(false);

export const setArchived = archivedStore.set;
export const setUnknownStaff = unknownStaffStore.set;

export function useIsArchived(): boolean {
  return useSyncExternalStore(archivedStore.subscribe, archivedStore.get);
}

export function useIsUnknownStaff(): boolean {
  return useSyncExternalStore(unknownStaffStore.subscribe, unknownStaffStore.get);
}
